/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LifetimeCoverage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputCurrency from 'DesignSystem/TysiaInput/TysiaInputCurrency/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function LifetimeCoverage({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/OrthodonticCoverage/OrthoCoverage/Content/LifetimeCoverage",
  onChange
  
}) {
let globalCurrentLocationPermissionsHasPatientInsuranceEditValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location.permissions.has_patient_insurance_edit',
format: fromFormat.not,
})
let planDetailsLifetimeCoverageValueData = fromData.useDataValue({ viewPath,
context: 'plan_details',
path: 'lifetime_coverage',
})
let planDetailsLifetimeCoverageChangeData = fromData.useDataChange({ viewPath,
context: 'plan_details',
path: 'lifetime_coverage',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="global.current_location.permissions.has_patient_insurance_edit"
 format="/Data/format.js not"
 disabled={globalCurrentLocationPermissionsHasPatientInsuranceEditValueData}
 data="plan_details.lifetime_coverage"
 value={planDetailsLifetimeCoverageValueData}
 onChange={planDetailsLifetimeCoverageChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Lifetime coverage $"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputCurrency
{...childProps}
  viewPath={`${viewPath}/TysiaInputCurrency`}
 placeholder="$0.00"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}